"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingInformation = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const uuid_1 = require("uuid");
const IsABAValidator_1 = require("../validators/IsABAValidator");
const IsBICValidator_1 = require("../validators/IsBICValidator");
const IsCompanyNumber_1 = require("../validators/IsCompanyNumber");
const IsIbanValidator_1 = require("../validators/IsIbanValidator");
const Address_1 = require("./Address");
const Document_1 = require("./Document");
const UBODeclaration_1 = require("./UBODeclaration");
const VatValidation_1 = require("./VatValidation");
let BillingInformation = class BillingInformation {
    constructor() {
        this._id = (0, uuid_1.v4)();
        this.isActive = false;
        this.isInvoiceInformation = false;
        this.address = new Address_1.Address();
        this.documents = [];
        // @IsDate()
        this.deletedAt = null;
        this.uboDeclaration = new UBODeclaration_1.UBODeclaration();
    }
    isLegal() {
        return this.type === legacy_enums_1.BillingInformationType.Legal;
    }
    isNatural() {
        return this.type === legacy_enums_1.BillingInformationType.Natural;
    }
    isSoletrader() {
        return this.type === legacy_enums_1.BillingInformationType.Soletrader;
    }
    isMangopayInformationRequired() {
        return this.payoutType === legacy_enums_1.PayoutType.Mangopay;
    }
    get invoiceCountryId() {
        if (this.type === legacy_enums_1.BillingInformationType.Natural) {
            return this.residenceCountryId;
        }
        return this.headquartersAddress.countryId;
    }
};
exports.BillingInformation = BillingInformation;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BillingInformation.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], BillingInformation.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.PayoutType),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], BillingInformation.prototype, "payoutType", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], BillingInformation.prototype, "isActive", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)((value) => (!value ? undefined : new Date(value))),
    (0, class_validator_1.ValidateIf)((bi) => bi.isActive),
    __metadata("design:type", Date)
], BillingInformation.prototype, "activatedAt", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], BillingInformation.prototype, "isInvoiceInformation", void 0);
__decorate([
    (0, class_validator_1.IsEmail)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BillingInformation.prototype, "email", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((bi) => (bi.isLegal() || bi.isSoletrader()) && (bi.isActive || bi.isInvoiceInformation)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BillingInformation.prototype, "bussinessName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((bi) => (bi.isMangopayInformationRequired() || bi.isNatural()) && (bi.isActive || bi.isInvoiceInformation)),
    __metadata("design:type", String)
], BillingInformation.prototype, "firstName", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((bi) => (bi.isMangopayInformationRequired() || bi.isNatural()) && (bi.isActive || bi.isInvoiceInformation)),
    __metadata("design:type", String)
], BillingInformation.prototype, "lastName", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)((value) => (!value ? undefined : new Date(value))),
    (0, class_validator_1.ValidateIf)((bi) => bi.isMangopayInformationRequired() && bi.isActive),
    __metadata("design:type", Date)
], BillingInformation.prototype, "birthdayAt", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Address_1.Address),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((bi) => (bi.isMangopayInformationRequired() || bi.isNatural()) && (bi.isActive || bi.isInvoiceInformation)),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", Address_1.Address)
], BillingInformation.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Address_1.Address),
    (0, class_validator_1.ValidateIf)((bi) => (bi.isLegal() || bi.isSoletrader()) && (bi.isActive || bi.isInvoiceInformation)),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", Address_1.Address)
], BillingInformation.prototype, "headquartersAddress", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((bi) => bi.isMangopayInformationRequired() && bi.isActive),
    __metadata("design:type", String)
], BillingInformation.prototype, "bankAccountCountryId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => VatValidation_1.VatValidation),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", VatValidation_1.VatValidation)
], BillingInformation.prototype, "vatValidation", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((bi) => bi.isMangopayInformationRequired() && bi.isActive),
    __metadata("design:type", String)
], BillingInformation.prototype, "nationalityCountryId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((bi) => (bi.isMangopayInformationRequired() || bi.isNatural()) && bi.isActive),
    __metadata("design:type", String)
], BillingInformation.prototype, "residenceCountryId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((bi) => bi.isMangopayInformationRequired() && bi.isActive),
    __metadata("design:type", String)
], BillingInformation.prototype, "taxResidenceCountryId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((bi) => bi.isNatural() && bi.isMangopayInformationRequired() && bi.isActive),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BillingInformation.prototype, "occupation", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Document_1.Document),
    (0, class_validator_1.ValidateIf)((bi) => bi.isMangopayInformationRequired() && bi.isActive),
    __metadata("design:type", Array)
], BillingInformation.prototype, "documents", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((bi) => bi.isNatural() && bi.isMangopayInformationRequired() && bi.isActive),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], BillingInformation.prototype, "annualIncomeRangeInEuro", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)((value) => (!value ? null : new Date(value))),
    __metadata("design:type", Object)
], BillingInformation.prototype, "deletedAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.ValidateIf)((bi) => (bi.isLegal() || bi.isSoletrader()) && bi.isActive && bi.isMangopayInformationRequired()),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.Validate)(IsCompanyNumber_1.IsCompanyNumber),
    (0, class_transformer_1.Transform)((value) => (value ? value.replace(/\s/g, "") : undefined)),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BillingInformation.prototype, "companyIdNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.ValidateIf)((bi) => bi.isLegal() && !!bi.taxIdentificationNumber && bi.isMangopayInformationRequired() && bi.isActive),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BillingInformation.prototype, "taxIdentificationNumber", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((bi) => bi.isMangopayInformationRequired() && (bi.isActive || bi.isInvoiceInformation)),
    __metadata("design:type", String)
], BillingInformation.prototype, "vatNumber", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.ValidateIf)((bi) => bi.isNatural() && !!bi.identifiedPersonNumber && bi.isMangopayInformationRequired() && bi.isActive),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BillingInformation.prototype, "identifiedPersonNumber", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => UBODeclaration_1.UBODeclaration),
    (0, class_validator_1.ValidateIf)((bi) => bi.isMangopayInformationRequired() && bi.isActive),
    __metadata("design:type", UBODeclaration_1.UBODeclaration)
], BillingInformation.prototype, "uboDeclaration", void 0);
__decorate([
    (0, class_validator_1.Validate)(IsIbanValidator_1.IsIbanValidator),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((bi) => bi.bankType === legacy_enums_1.CountryBankType.IBAN && bi.isMangopayInformationRequired() && bi.isActive),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BillingInformation.prototype, "iban", void 0);
__decorate([
    (0, class_validator_1.Validate)(IsBICValidator_1.IsBICValidator),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((bi) => bi.bankType === legacy_enums_1.CountryBankType.BIC && bi.isMangopayInformationRequired() && bi.isActive),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BillingInformation.prototype, "bic", void 0);
__decorate([
    (0, class_validator_1.Validate)(IsABAValidator_1.IsABAValidator),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((bi) => bi.bankType === legacy_enums_1.CountryBankType.US && bi.isMangopayInformationRequired() && bi.isActive),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BillingInformation.prototype, "aba", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((bi) => (bi.bankType === legacy_enums_1.CountryBankType.BIC || bi.bankType === legacy_enums_1.CountryBankType.US) &&
        bi.isMangopayInformationRequired() &&
        bi.isActive),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BillingInformation.prototype, "accountNumber", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(legacy_enums_1.CountryBankType),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((bi) => bi.isMangopayInformationRequired() && bi.isActive),
    __metadata("design:type", Number)
], BillingInformation.prototype, "bankType", void 0);
exports.BillingInformation = BillingInformation = __decorate([
    (0, class_transformer_1.Exclude)()
], BillingInformation);
//# sourceMappingURL=BillingInformation.js.map